let getters = {
  TASKBOARDS: (state) => {
    return state.taskBoards;
  },
};

export default getters;
